module.exports = __webpack_public_path__ + "img/logo.adf894b5.png";